import validator from "validator";
import { Link } from "react-router-dom";
import { FlagIcon } from "react-flag-kit";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Fragment, useEffect, useState } from "react";

import Select from "@material-ui/core/Select";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContentText from "@material-ui/core/DialogContentText";

import Congratulations from "./Congratulations";
import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import { getSubTypeID, postTicket } from "../../store/middleware";
import ImgCustomerService from "../../assets/images/img_cs-openticket.png";
import { setTicketCreated } from "../../store/slices/customerService.slice";
import InputTicketTypes from "../../components/elements/Inputs/InputTicketTypes";
import InputTicketSubTypes from "../../components/elements/Inputs/InputTicketSubTypes";
import CustomerService from "../../assets/images/icons/icon_customerservice_header.svg";

import { Box } from "./styles";

function NewTicket() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { allLingos } = useSelector((state) => state.genericReducer);
  const { ticket } = useSelector((state) => state.customerServiceReducer);

  const [inputType, setInputType] = useState("");
  const [inputTitle, setInputTitle] = useState("");
  const [openalert, setOpenAlert] = useState(false);
  const [validations, setValidations] = useState({});
  const [inputSubType, setInputSubType] = useState("");
  const [inputDescription, setInputDescription] = useState("");
  const [inputLingoLanguage, setInputLingoLanguage] = useState("");

  const closeAlert = () => setOpenAlert(false);
  const loadInfos = () => dispatch(setTicketCreated(null));

  const handleSubmit = () => {
    if (validateForm()) {
      let newObjTicketAdd = {};
      newObjTicketAdd.ticketTypeId = Number(inputType);
      newObjTicketAdd.ticketSubTypeId = Number(inputSubType);
      newObjTicketAdd.description = inputDescription;
      newObjTicketAdd.lingoLanguageId = Number(inputLingoLanguage);
      newObjTicketAdd.title = inputTitle;
      newObjTicketAdd.active = true;

      dispatch(postTicket(newObjTicketAdd));
    } else {
      setOpenAlert(true);
    }
  };

  const inputChange = (e, name) => {
    const { value } = e.target;
    switch (name) {
      case "type":
        setInputType(value);
        break;
      case "subType":
        setInputSubType(value);
        break;
      case "lingoLanguage":
        setInputLingoLanguage(value);
        break;
      case "title":
        setInputTitle(value);
        break;
      case "description":
        setInputDescription(value);
        break;
      default:
        break;
    }

    validateForm();
    name === "type" && value !== "" && dispatch(getSubTypeID(value));
  };

  const validateForm = () => {
    let validations = [];
    validations = {
      type: validator.isEmpty(inputType.toString()),
      subType: validator.isEmpty(inputSubType.toString()),
      lingoLanguage: validator.isEmpty(inputLingoLanguage.toString()),
      title: validator.isEmpty(inputTitle),
      description: validator.isEmpty(inputDescription),
    };

    const identifiers = Object.keys(validations);
    const hasError = identifiers.filter(function (input) {
      return validations[input];
    });

    setValidations(validations);
    return hasError.length > 0 ? false : true;
  };

  useEffect(() => {
    loadInfos();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <SideMenu lang={"english"} />
      <section>
        <Header
          title={t("OPEN_NEW_TICKET")}
          icon={<img src={CustomerService} alt="Customer Service" />}
          typeIcon="custom"
          t={t}
        />
        <div className="contentCS">
          <Box>
            {ticket ? (
              <Congratulations />
            ) : (
              <Fragment>
                <div className="bigBox">
                  <div className="boxCS">
                    <form>
                      <InputTicketTypes
                        name="type"
                        type="ticketTypes"
                        value={inputType}
                        required="true"
                        onChange={inputChange}
                        error={validations["type"]}
                      />
                      <InputTicketSubTypes
                        name="subType"
                        type="ticketSubTypes"
                        value={inputSubType}
                        required="true"
                        onChange={inputChange}
                        error={validations["subType"]}
                      />

                      <div>
                        <label htmlFor="flag">Lingo</label>
                        <span className={`${validations["lingoLanguage"] ? "invalid" : ""}`}>
                          {t("REQUIRED_FIELD")}
                        </span>
                      </div>
                      <Select
                        disableUnderline
                        value={inputLingoLanguage}
                        onChange={(e) => inputChange(e, "lingoLanguage")}
                        name="lingoLanguage"
                        className="input-lingo Select"
                        displayEmpty
                      >
                        <MenuItem value={""}>{t("SELECT")}</MenuItem>
                        {allLingos.map((item) => {
                          return (
                            item.active === true && (
                              <MenuItem key={item.id} value={item.id}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                  <FlagIcon code={item.flag} style={{ marginRight: "5px" }} />{" "}
                                  <p>{item.language.name}</p>
                                </div>
                              </MenuItem>
                            )
                          );
                        })}
                      </Select>
                      <div>
                        <label htmlFor="title">{t("TITLE")}</label>
                        <span className={`${validations["title"] ? "invalid" : ""}`}>{t("REQUIRED_FIELD")}</span>
                      </div>
                      <input
                        value={inputTitle}
                        onChange={(e) => inputChange(e, "title")}
                        name="title"
                        maxLength="128"
                      />

                      <div>
                        <label htmlFor="description">{t("DESCRIPTION")}</label>
                        <span className={`${validations["description"] ? "invalid" : ""}`}>{t("REQUIRED_FIELD")}</span>
                      </div>
                      <textarea
                        value={inputDescription}
                        onChange={(e) => inputChange(e, "description")}
                        name="description"
                        maxLength="2000"
                      />
                    </form>

                    <div className="imgOpenTicket">
                      <img src={ImgCustomerService} alt="Customer Service" />
                    </div>
                  </div>
                </div>
                <div className="buttons">
                  <Link to={`/customer-service`}>
                    <button type="button">{t("CANCEL")}</button>
                  </Link>
                  <button
                    type="button"
                    onClick={(e) => {
                      handleSubmit(e);
                    }}
                  >
                    {t("BTN_SAVE")}
                  </button>
                </div>
              </Fragment>
            )}
            <Dialog
              open={openalert}
              onClose={() => closeAlert()}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{t("INVALID_FORM_TITLE")}</DialogTitle>
              <DialogContent>
                <DialogContentText id="dialog-error-message">{t("INVALID_FORM_DESCRIPTION")}</DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => closeAlert()} color="primary" autoFocus>
                  {t("CLOSE")}
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        </div>
      </section>
    </div>
  );
}

export default NewTicket;
